<div>
<label for="table">{{label}}
</label>
<table id="table" class="table table-bordered">
  <thead>
  <tr>
    <th *ngFor="let col of header">{{col}}
    </th>
  </tr>
  </thead>
</table>
</div>
